import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import MyButton from "../../util/MyButton";
import PropTypes from "prop-types";
import PostScream from "../scream/PostScream";
import Notifications from "./Notifications";
import "../../App.css";
// ** reacr redux
import { connect } from "react-redux";
//** Importing material ui appbar */
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
// import AddIcon from "@material-ui/icons/Add";
import HomeIcon from "@material-ui/icons/Home";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AppsIcon from "@material-ui/icons/Apps";

// import UploadScream from "./UploadScream";
// import { UPLOAD_SCREAM } from "../redux/types";

class Navbar extends Component {
  render() {
    const {
      authenticated,
      credentials: { userType },
    } = this.props;

    const addScreamButton =
      userType === "0" ? (
        <Fragment>
          <Link to="/">
            <MyButton tip="Home">
              <HomeIcon style={{ color: "white" }} />
            </MyButton>
          </Link>
          <Link to="/profile">
            <MyButton tip="User Details">
              <AccountCircleIcon style={{ color: "white" }} />
            </MyButton>
          </Link>
        </Fragment>
      ) : userType === "1" ? (
        <Fragment>
          {/* <MyButton tip="Post a scream!">
            <AddIcon style={{ color: "white" }} />
          </MyButton> */}
          <PostScream />
          <Link to="/">
            <MyButton tip="Home">
              <HomeIcon style={{ color: "white" }} />
            </MyButton>
          </Link>
          <Notifications style={{ color: "white" }} />
          <Link to="/profile">
            <MyButton tip="User Details">
              <AccountCircleIcon style={{ color: "white" }} />
            </MyButton>
          </Link>
          {/* <Button color="inherit" component={Link} to="/UploadScream">
            Upload Scream
          </Button> */}
        </Fragment>
      ) : userType === "2" ? (
        <Fragment>
          {/* <MyButton tip="Post a scream!">
            <AddIcon style={{ color: "white" }} />
          </MyButton> */}
          <PostScream />
          <Link to="/">
            <MyButton tip="Home">
              <HomeIcon style={{ color: "white" }} />
            </MyButton>
          </Link>
          <Notifications style={{ color: "white" }} />
          <Link to="/profile">
            <MyButton tip="User Details">
              <AccountCircleIcon style={{ color: "white" }} />
            </MyButton>
          </Link>
          <MyButton tip="Authorize/Unauthorize users from posting screams">
            <AppsIcon style={{ color: "white" }} />
          </MyButton>

          {/* <Button color="inherit" component={Link} to="/profile">
            Profile
          </Button> */}
        </Fragment>
      ) : null;
    //{addScreamButton}

    return (
      <AppBar>
        <Toolbar style={{ margin: "auto" }}>
          {authenticated ? (
            <Fragment>
              {addScreamButton}
              {/* <MyButton tip="Post a scream!">
                <AddIcon style={{ color: "white" }} />
              </MyButton>
              <Link to="/">
                <MyButton tip="Home">
                  <HomeIcon style={{ color: "white" }} />
                </MyButton>
              </Link>
              <MyButton tip="Notifications">
                <Notifications style={{ color: "white" }} />
              </MyButton>
              <MyButton tip="User Details">
                <AccountCircleIcon style={{ color: "white" }} />
              </MyButton> */}
            </Fragment>
          ) : (
            <Fragment>
              <Button color="inherit" component={Link} to="/login">
                Login
              </Button>
              <Button color="inherit" component={Link} to="/signup">
                Signup
              </Button>
              <Button color="inherit" component={Link} to="/">
                Home
              </Button>
              {/* <Button color="inherit" component={Link} to="/profile">
                Profile
              </Button> */}
            </Fragment>
          )}
        </Toolbar>
      </AppBar>
    );
  }
}

Navbar.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  // user: PropTypes.object.isRequired,
  credentials: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  authenticated: state.user.authenticated,
  // user: PropTypes.object.isRequired,

  credentials: state.user.credentials,
});

export default connect(mapStateToProps)(Navbar);
